<template>
  <!--
      作者：fzf
      时间：2025-06-16
      描述：会员-用户列表-会员运营礼包
  -->
  <div>
  <el-dialog title="会员运营礼包" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">

       <el-form-item label="运营礼包"  :label-width="formLabelWidth">
          <div>
            <el-radio v-model="grade4" :label="0">否</el-radio>
            <el-radio v-model="grade4" :label="1">是</el-radio>
            <div class="tips">如果选了【是】则会在会员等级为【运营官】推送运营礼包；若已推送的不会再推送</div>
          </div>
        </el-form-item>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
         open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        grade4:0
      };
    },
    props: ['open_edit_pg', 'form'],
    created() {
      this.dialogVisible = this.open_edit_pg;
    },
    methods: {

      /*修改用户*/
      editUser() {
        let self = this;
        self.loading = true;
        let params = self.form;
        params.grade4 = self.grade4;
        UserApi.edituserpg(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，用户修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        console.log(e)
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/GradePg.vue